import { h } from 'preact';
import { DeviceVariance } from '@cube/blocks';
import Current from '../current';
import { Text } from 'preact-i18n';
import style from './style';
import cx from 'classnames';

const WeatherCompact = ({ conditions, currentUnit, config, location, changeUnit }) => (
	<DeviceVariance other={
		<div key="container" class={cx(style.container, style.compact)}>
			<Current
				isCompact
				today={conditions}
				unit={currentUnit}
				changeUnit={changeUnit}
			/>
			<div class={style.moreOnAndradarFullForecast}>
				<div class={style.radarFullForecast}>
					<a href={config.radarFullForecastCompactViewUrl} target="_blank"	rel="noopener noreferrer">
						<Text id="radarFullForecast" />
					</a>
				</div>
			</div>
		</div>
	} phone={
		<div key="container" class={cx(style.container, style.compact, style.phone)}>
			<Current
				isCompact
				today={conditions}
				unit={currentUnit}
				changeUnit={changeUnit}
			/>
			<div class={style.moreOnAndradarFullForecast}>
				<div class={style.radarFullForecast}>
					<div>
						<span class={style.location}>{location.name}</span>
					</div>
					<a href={config.radarFullForecastCompactViewUrl} target="_blank"	rel="noopener noreferrer">
						<Text id="radarFullForecast" />
					</a>
				</div>
			</div>
		</div>
	}
	/>
);
export default WeatherCompact;



// WEBPACK FOOTER //
// ../node_modules/@cube/weather-widget/src/components/weather/weather-compact.js